module.exports = "<div class=icon-button> <button class=\"no-pointers button\" ng-disabled=$ctrl.isDisabled ng-class=\"{ 'disabled-left': $ctrl.disabledDirection == 'left', 'disabled-right': $ctrl.disabledDirection == 'right' }\"> <div class={{$ctrl.icon}} ng-class=\"{ 'inverted': $ctrl.inverted} \"></div> </button> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/icon-button/icon-button.html
 ** module id = 68
 ** module chunks = 0
 **/